$(document).ready(function () {
  var musicObject = {
    CHANGE_COLOR: "https://cdn.shopify.com/s/files/1/0703/7412/9889/files/changeColor.mp3?v=1730953914",
    SELECTING_CATEGORY: "https://cdn.shopify.com/s/files/1/0703/7412/9889/files/selectingCategory.mp3?v=1730953913",
    SELECTING_SUBCATEGORY: "https://cdn.shopify.com/s/files/1/0703/7412/9889/files/selectingSubcategory.mp3?v=1730953914",
    SELECT_FAVORITE_PATCH: "https://cdn.shopify.com/s/files/1/0703/7412/9889/files/selectFavoritePatch.mp3?v=1730953913",
    START_DESIGN: "https://cdn.shopify.com/s/files/1/0703/7412/9889/files/startDesign.mp3?v=1730953914",
    MORE_PATCHES: "https://cdn.shopify.com/s/files/1/0703/7412/9889/files/morePatches.mp3?v=1730953914",
    VIEW: "https://cdn.shopify.com/s/files/1/0703/7412/9889/files/view.mp3?v=1730953913",
    ERROR_FIT_SOUND: "https://cdn.shopify.com/s/files/1/0703/7412/9889/files/errorFitSound.mp3?v=1730953913",
    NORMAL_FIT_PATCH: "https://cdn.shopify.com/s/files/1/0703/7412/9889/files/normalFitPatch.mp3?v=1730953913",
    SUPER_SIZE_FIT_PATCH: "https://cdn.shopify.com/s/files/1/0703/7412/9889/files/superSizeFitPatch.mp3?v=1730953913",
    ADD_TO_BAG: "https://cdn.shopify.com/s/files/1/0703/7412/9889/files/addToBag.mp3?v=1730953914"
  }
  function playMusic(url) {
    new Audio(url).play();
  }
    /*-------- Product Image Zoom JS Start --------*/
    var scale = 1,
      minScale = 1,
      maxScale = 2.4,
      ZoomDiv = $(".main-bag-product-img-inner");
    function applyScale() {
      ZoomDiv.css({
        transform: "scale(" + scale + ")",
        height: "100%",
      });
      $(".draggable").draggable({
        helper: function () {
          var clone = $(this).clone();
          clone.appendTo(".ui-droppable-layout").css({ zIndex: 10 });
          clone.find("img").eq(0).wrap('<div class="img-wrapper"></div>');
          clone.data("id", Date.now());
          return clone;
        },
        cursor: "move",
        containment: "document",
        stop: function (event, ui) {
          var id = $(ui.helper).find('img').attr('product-id');
          setTimeout(function() {
            if ($('[data-main-droppable] img[product-id="'+id+'"]').length == 0) {
              playMusic(musicObject.ERROR_FIT_SOUND);
            }
          }, 500)
        },
      });
    }
    $(".bag-product-img-btn-zoom").on("click", function () {
      if (scale < maxScale) {
        scale += 0.2;
        applyScale();
        if (!ZoomDiv.hasClass("img-zoom")) {
          ZoomDiv.addClass("img-zoom");
        }
      }
    });
    $(".bag-product-img-btn-zoom-out").on("click", function () {
      if (scale > minScale) {
        scale -= 0.2;
        applyScale();
      }
      if (scale === minScale) {
        ZoomDiv.css({
          transform: "",
          height: "",
        });
        if (ZoomDiv.hasClass("img-zoom")) {
          ZoomDiv.removeClass("img-zoom");
        }
      }
    });
  
    /*-------- Product Image Zoom JS End --------*/
    /*-------- Patches JS Start --------*/
    $("body").on("click", ".filter-grid-btn", function (e) {
      e.preventDefault();
      if ($(this).hasClass("active")) {
        return;
      }
      $(".filter-grid-btn").removeClass("active");
      $(this).addClass("active");
      $(".filter-bottom-tab").hide();
      $(`.filter-bottom-tab[data-filter-btn="${$(this).attr("data-filter-btn")}"]`).fadeIn();
      $(`.filter-bottom-tab[data-filter-btn="${$(this).attr("data-filter-btn")}"]`).find(".filter-grid-btn-inner").eq(0).trigger("click");
      playMusic(musicObject.SELECTING_CATEGORY);
    });
    $("body").on("click", ".filter-grid-btn-inner", function (e) {
      e.preventDefault();
      if ($(this).hasClass("active")) {
        return;
      }
      $(".filter-grid-btn-inner").removeClass("active");
      $(this).addClass("active");
      $(".filter-bottom-tab-inner").hide();
      $(`.filter-bottom-tab-inner[data-filter-btn="${$(this).attr("data-filter-btn")}"]`).fadeIn();
      playMusic(musicObject.SELECTING_SUBCATEGORY);
    });
    $("body").on(
      "click",
      ".bag-bottom-patches-heading-center .ct-button1",
      function (e) {
        e.preventDefault();
        if (
          $(this).parents(".bag-bottom-patches-heading-inner").hasClass("active")
        ) {
          $(this)
            .parents(".bag-bottom-patches-heading-inner")
            .removeClass("active");
          $(".bag-bottom-patches-tab-main").hide();
          $(".model-overlay").removeClass("open");
          $("body").removeClass("overflow-hidden");
          $(
            ".bag-bottom-patches-heading-center .ct-button1 span:not(.icon)"
          ).text("More Patches");
          playMusic(musicObject.START_DESIGN);
        } else {
          $(this).parents(".bag-bottom-patches-heading-inner").addClass("active");
          $(".bag-bottom-patches-tab-main").fadeIn();
          $(".model-overlay").addClass("open");
          $("body").addClass("overflow-hidden");
          $(
            ".bag-bottom-patches-heading-center .ct-button1 span:not(.icon)"
          ).text("Start Designing!");
          playMusic(musicObject.MORE_PATCHES);
        }
      }
    );
    $("body").on(
      
      "click",
      ".bag-bottom-patches-heading-right .ct-button-2",
      function (e) {
        e.preventDefault();
        $(".bag-bottom-patches-heading-inner").removeClass("active");
        $(".bag-bottom-patches-tab-main").hide();
        $(".model-overlay").removeClass("open");
        $("body").removeClass("overflow-hidden");
        $(".bag-bottom-patches-heading-center .ct-button1 span:not(.icon)").text(
          "More Patches"
        );
        playMusic(musicObject.START_DESIGN);
      }
    );
    /*-------- Patches JS End --------*/
    /*-------- Patches slider JS Start --------*/
    $(".bag-patches-tab-slider:not([data-add-fav-item])").each(function (index,element) {
      const $navContainer = $(this).parents(".bag-patches-tab-body-slider").find(".bag-patches-slider-nav");
      $navContainer.addClass(`bag-patches-slider-nav-${index}`);
      new Swiper(element, {
        spaceBetween: 10,
        speed: 300,
        loop: false,
        slidesPerView: 1,
        disableOnInteraction: false,
        allowTouchMove: false,
        navigation: {
          nextEl: `.bag-patches-slider-nav-${index} .bag-patches-slider-next`,
          prevEl: `.bag-patches-slider-nav-${index} .bag-patches-slider-prev`,
        },
        breakpoints: {
          1024: {
            slidesPerView: 8,
            spaceBetween: 10,
          },
          1440: {
            slidesPerView: 13,
            spaceBetween: 10,
          },
          1600: {
            slidesPerView: 15,
            spaceBetween: 10,
          },
        },
      });
    });
    
  var PatchedSlider = new Swiper("[data-add-fav-item]", {
    spaceBetween: 10,
    speed: 300,
    loop: false,
    slidesPerView: 1,
    disableOnInteraction: false,
    allowTouchMove: false,
    navigation: {
      nextEl: `[data-add-fav-item-nav] .bag-patches-slider-next`,
      prevEl: `[data-add-fav-item-nav] .bag-patches-slider-prev`,
    },
    breakpoints: {
      1024: {
        slidesPerView: 8,
        spaceBetween: 10,
      },
      1440: {
        slidesPerView: 13,
        spaceBetween: 10,
      },
      1600: {
        slidesPerView: 15,
        spaceBetween: 10,
      },
    },
  });
  
    /*-------- Patches slider JS End --------*/
    /*-------- Cart model JS Start --------*/
    $("body").on("click", ".main-bag-product-cart .ct-button-cart", function (e) {
      e.preventDefault();
      $(".model-order-section, .model-overlay").addClass("open");
      $("body").addClass("overflow-hidden");
    });
    $("body").on("click", ".model-order-inner .model-order-close", function (e) {
      e.preventDefault();
      $(".model-order-section, .model-overlay").removeClass("open");
      $("body").removeClass("overflow-hidden");
    });
    $("body").on("click", ".model-overlay", function (e) {
      e.preventDefault();
      $(
        ".model-order-section, .model-overlay, .model-common-section, .model-add-bag-section"
      ).removeClass("open");
      $("body").removeClass("overflow-hidden");
      $(".bag-bottom-patches-heading-inner").removeClass("active");
      $(".bag-bottom-patches-tab-main").hide();
      $(".bag-bottom-patches-heading-center .ct-button1 span:not(.icon)").text(
        "More Patches"
      );
      playMusic(musicObject.START_DESIGN);
    });
    /*-------- Cart model JS End --------*/
    /*-------- Common model JS Start --------*/
    $("body").on("click", ".ct-model-comm-btn", function (e) {
      e.preventDefault();
      $(
        `.model-common-section[data-model-name="${$(this).attr(
          "data-model-name"
        )}"]`
      ).addClass("open");
      $(".model-overlay").addClass("open");
      $("body").addClass("overflow-hidden");
    });
    $("body").on("click", ".ct-model-common-close", function (e) {
      e.preventDefault();
      $(".model-common-section, .model-overlay").removeClass("open");
      $("body").removeClass("overflow-hidden");
    });
    /*-------- Common model JS End --------*/
  
    /*-------- Bag mobile header JS Start --------*/
    $("body").on("click", "[data-open-patches]", function (e) {
      e.preventDefault();
      if (!$("[data-open-patches]").hasClass("active")) {
        $("[data-open-patches]").addClass("active");
        $(
          ".main-bag-mob-header-inner, .bag-mob-header-bottom-body-section"
        ).addClass("open");
        $(".bag-mob-header-bottom-heading .step-model-close-btn").fadeIn();
        $("[data-open-patches] span:not(.icon)").text("Patches");
        playMusic(musicObject.MORE_PATCHES);
      } else {
        closePatchModal();
        playMusic(musicObject.START_DESIGN);
      }
    });
    $("body").on(
      "click",
      ".bag-mob-header-bottom-heading .step-model-close-btn",
      function (e) {
        e.preventDefault();
        closePatchModal();
        playMusic(musicObject.START_DESIGN);
      }
    );
    function closePatchModal() {
      $(
        "[data-open-patches], .patched-item-step-1, .patched-item-step-2"
      ).removeClass("active");
      $(
        ".main-bag-mob-header-inner,.bag-mob-header-bottom-body-section"
      ).removeClass("open");
      $(".main-mobile-patched-category,.mobile-patched-category-inner").fadeIn();
      $(".patched-item-step-1-body,.patched-item-step-2-body").removeClass(
        "show"
      );
      $(".bag-mob-header-bottom-heading .ct-button1")
        .removeAttr("open-patche-layer", "")
        .removeClass("active-step");
      $("[data-open-patches] span:not(.icon)").text("More Patches");
    }
    /*-------- Bag mobile header JS End --------*/
    /*-------- Bag mobile Step JS Start --------*/
    $("body").on("click", ".patched-item-step-1", function (e) {
      e.preventDefault();
      $(".main-mobile-patched-category").hide();
      $(
        `.patched-item-step-1-body[data-step-first="${$(this).attr(
          "data-collection-name"
        )}"]`
      ).addClass("show");
  
      $(".bag-mob-header-bottom-heading .ct-button1")
        .addClass("active-step")
        .attr("open-patche-layer", `.patched-item-step-1-body`);
      $("[data-open-patches] span:not(.icon)").text($(this).find("h4").text());
      playMusic(musicObject.SELECTING_CATEGORY);
    });
  
    $("body").on("click", ".patched-item-step-2", function (e) {
      e.preventDefault();
      $(this).parents(".mobile-patched-category-inner").hide();
      $(
        `.patched-item-step-2-body[data-step-second="${$(this).attr(
          "data-step-second"
        )}"]`
      ).addClass("show");
      $(".bag-mob-header-bottom-heading .ct-button1").attr(
        "open-patche-layer",
        `.patched-item-step-2-body`
      );
      $("[data-open-patches] span:not(.icon)").text($(this).find("h4").text());
      playMusic(musicObject.SELECTING_SUBCATEGORY);
    });
  
    $("body").on("click", ".bag-mob-header-step-btn-next", function () {
      PatchesNavigation("next", $(this));
      playMusic(musicObject.SELECTING_CATEGORY);
    });
  
    $("body").on("click", ".bag-mob-header-step-btn-prev", function () {
      PatchesNavigation("prev", $(this));
      playMusic(musicObject.SELECTING_CATEGORY);
    });
  
    function PatchesNavigation(navigation, button) {
      var PatchesCollection = button
        .parents(".ct-button1.active-step")
        .attr("open-patche-layer");
      var $ParentEle = $(`${PatchesCollection}.show`).parent();
      var $activePatches = $ParentEle.find(`${PatchesCollection}.show`);
      var $Patcheslength = $activePatches[navigation](PatchesCollection);
      var position = navigation == "next" ? "first" : "last";
      var patchesTabTitle = "";
      if ($Patcheslength.length) {
        $activePatches.removeClass("show");
        $Patcheslength.addClass("show");
        patchesTabTitle = $Patcheslength.attr("data-patches-heading");
      } else {
        $activePatches.removeClass("show");
        $ParentEle.find(PatchesCollection)[position]().addClass("show");
        patchesTabTitle = $ParentEle
          .find(PatchesCollection)
          [position]()
          .attr("data-patches-heading");
      }
      $("[data-open-patches] span:not(.icon)").text(patchesTabTitle);
    }
  
    /*-------- Bag mobile Step JS End --------*/
    /*-------- Add baf model JS Start --------*/
    // $(".bag-product-modifi-add-btn .ct-button1").on("click", function (e) {
    //   e.preventDefault();
    //   $(".model-add-bag-section, .model-overlay").addClass("open");
    //   $("body").addClass("overflow-hidden");
    // });
    // $(".model-add-bag-box .ct-add-bag-close").on("click", function (e) {
    //   e.preventDefault();
    //   $(".model-add-bag-section, .model-overlay").removeClass("open");
    //   $("body").removeClass("overflow-hidden");
    // });
    /*-------- Add baf model JS End --------*/
  
    function varaintSelect(form) {
      var section = $("[data-custom-product-main]").attr("data-section");
      var url = $("[data-custom-product-main]").attr("data-url");
      var getVariantData = JSON.parse(
        form.find('[type="application/json"]').text()
      );
      var fieldsets = form.find("[data-swatch]").toArray();
      var options = [];
  
      $.each(fieldsets, function (i, v) {
        var value = $(v).find("input[type='radio']:checked").val();
        options.push(value);
      });
  
      var currentVariant;
  
      $.each(getVariantData, function (i, variant) {
        var lll = 0;
        $.each(variant.options, function (index, option) {
          if (options[index] !== option) {
            lll = 1;
          }
        });
        if (lll == 0) {
          currentVariant = variant;
        }
      });
  
      if (!currentVariant) {
      } else {
        if (currentVariant.featured_media) {
          var src = currentVariant.featured_media.preview_image.src;
          var alt = currentVariant.featured_media.alt;
          var newSmallMedia = $("[data-small-image-change]");
          newSmallMedia.html(
            '<img src="' +
              src +
              '&amp;width=70" alt="' +
              alt +
              '" srcset="' +
              src +
              "&amp;width=50 50w, " +
              src +
              '&amp;width=70 70w" width="70" height="89">'
          );
          var src = currentVariant.featured_media.preview_image.src;
          var newMedia = $("[data-main-image]");
          newMedia.find('img').attr('src', src)
        }
        window.selectedVariant = currentVariant;
        $('[data-default-product]').attr('data-var-id', currentVariant.id);
        playMusic(musicObject.CHANGE_COLOR);
        $.get(
          url + "?variant=" + currentVariant.id + "&section_id=" + section,
          function (data) {
            var change_content_1 = $(data).find("[data-change-content-1]");
            $("[data-custom-product-main] [data-change-content-1]").html(
              change_content_1.html()
            );
            var change_content_2 = $(data).find("[data-change-content-2]");
            $("[data-custom-product-main] [data-change-content-2]").html(
              change_content_2.html()
            );
          }
        );
      }
    }
    $("body").on("change", "[data-form] input", function () {
      var form = $(this).closest("[data-form]");
      varaintSelect(form);
    });
    /*-------------- Drag and Drop JS Start --------------*/
    var stateHistory = [];
    var stateProduct = [];
    function checkitems(id,appendOrder) {
      return stateHistory
        .filter(items => items.id == id && items.appendOrder == appendOrder)
        .map(item => ({ ...item, append: false }));
    }
    
    function saveState(element, append) {
      var id = element.attr("data-product-id");
      var position = element.position();
      var rotation = element.attr("data-rotate") || 0;
      var appendOrder = element.attr("patches-append-order");
      var newHistory;
      if (id) {
        newHistory = {
          appendOrder,
          id,
          left: position.left,
          top: position.top,
          rotation,
          append: append ? true : false ,
        }
        if (stateHistory.length == 0) {
          stateHistory = [...stateHistory, newHistory];
        } else {
          var prevItems = stateHistory[stateHistory.length - 1];
          if((prevItems.id == id && prevItems.appendOrder == appendOrder) || append){
            stateHistory = [...stateHistory, newHistory];
          }else{
            var lastChageEle = checkitems(id,appendOrder)
            if(lastChageEle.length > 0){
              stateHistory = [...stateHistory,lastChageEle[lastChageEle.length - 1], newHistory];
            }
          }
        }
      }
    }

    function saveProduct(element,checkQty) {
      var id = element.attr("data-product-id");
      var vid = element.find('img').attr("data-varid");
      var src = element.find('img').attr("data-src");
      var title = element.find('img').attr("data-title");
      var price = element.find('img').attr("data-price");
      var isMatchFound = stateProduct.some(function(item) {
          return item.id === id;
      });
      var qty = 1;
      var newProduct;
      if (id) {
        newProduct = {
          id,
          vid,
          src,
          title,
          price,
          qty
        }
        if (!isMatchFound) {
          stateProduct = [...stateProduct, newProduct];
        } else {
          var newarray = stateProduct.map((item) => {
            if (item.id == id) {
              var proQty = checkQty == 'plus' ? (item.qty + 1) : (item.qty - 1);
              if (proQty > 0) {
                return {...item, qty: proQty}
              } else {
                return null; 
              }
            }
            return item;
          })
          .filter(item => item !== null);
          stateProduct = newarray;
        }
      }
      var price = window.selectedVariant.price;
      var priceEle = $('[data-price]');
      var cartAddEle = $('[data-add-cart]');
      var deskProductEle = $('[data-product-desktop]');
      var mobProductEle = $('[data-product-mobile]');
      var deskHtml = ``;
      var mobHtml = ``;
      if (stateProduct.length > 0) {
        $.each(stateProduct, function(i, v) {
          price += (v.qty * v.price);
          deskHtml += `<div class="model-order-product-items align-center" data-var-id="${v.vid}">
            <div class="order-product-div order-product-img">
              <img src="${v.src}" alt="${v.title}">
            </div>
            <div class="order-product-div order-product-name">
              <p>${v.title}</p>
            </div>
            <div class="order-product-div order-product-qty">
              <p>Qty: ${v.qty}</p>
            </div>
            <div class="order-product-div order-product-price">
              <p>${Shopify.formatMoney((v.qty * v.price))}</p>
            </div>
          </div>`
          mobHtml += `<div class="model-order-product-items flex align-center" data-var-id="${v.vid}">
            <div class="order-product-div order-product-img">
              <img src="${v.src}" alt="${v.title}">
            </div>
            <div class="order-product-div order-product-left">
              <div class="order-product-name">
                <p>${v.title}</p>
              </div>
              <div class="order-product-qty">
                <p>Qty: ${v.qty}</p>
              </div>
            </div>
            <div class="order-product-div order-product-price">
              <p>${Shopify.formatMoney((v.qty * v.price))}</p>
            </div>
          </div>`
        });
        cartAddEle.removeAttr('disabled');
      } else {
        cartAddEle.attr('disabled', 'disabled');
      }
      deskProductEle.find('.model-order-product-items:not([data-default-product])').remove();
      mobProductEle.find('.model-order-product-items:not([data-default-product])').remove();
      deskProductEle.append(deskHtml);
      mobProductEle.append(mobHtml);
      priceEle.html(Shopify.formatMoney(price));
    }
    var appendOrder = 1;
    $(".draggable").draggable({
      helper: function () {
        var clone = $(this).clone();
        clone.appendTo(".ui-droppable-layout").css({ zIndex: 10 });
        clone.find("img").eq(0).wrap('<div class="img-wrapper"></div>');
        clone.data("id", Date.now());
        return clone;
      },
      cursor: "move",
      containment: "document",
      stop: function (event, ui) {
        var id = $(ui.helper).find('img').attr('product-id');
        setTimeout(function() {
          if ($('[data-main-droppable] img[product-id="'+id+'"]').length == 0) {
            playMusic(musicObject.ERROR_FIT_SOUND);
          }
        }, 500)
      },
    });
    
  $(".ui-droppable-layout[data-main-droppable]").droppable({
    activeClass: "ui-state-hover",
    accept: ".draggable",
     deactivate: function( event, ui ) {
       if (ui.draggable.hasClass("dropped")) {
         $(".patches-tab-items-img").removeClass('active');
         jQuery(ui.draggable).addClass("active")
         saveState(ui.draggable);
       }
    },
    drop: function (event, ui) { 
      if (!ui.draggable.hasClass("dropped")) {
        $(".patches-tab-items-img").removeClass('active');
        clone = jQuery(ui.draggable).clone().addClass("dropped active").draggable({
            containment: ".ui-droppable-layout[data-main-droppable]",          
          });
          clone.attr("data-product-id",clone.find("img").attr("product-id")).attr('data-rotate',0).attr('patches-append-order',appendOrder++).css({
          left: ui.position.left,
          top: ui.position.top,
          position: "absolute",
        }).append('<div class="letter-drop-actions"><span class="btn rotate"><img src="https://cdn.shopify.com/s/files/1/0703/7412/9889/files/rotate-icon.svg" /></span><span class="btn remove"><img src="https://cdn.shopify.com/s/files/1/0703/7412/9889/files/delete-icon.svg"/></span></div>');
        clone.find("img").eq(0).wrap('<div class="img-wrapper"></div>');
        $(this).append(clone);
        var patchesImage = clone.find("img").eq(0);
        clone.find(".img-wrapper").on({
          click: function () {
            if (!$(this).parent().hasClass("active")) {
              $(".patches-tab-items-img").removeClass("active");
              $(this).parents(".patches-tab-items-img").addClass("active");
              var currentRotateEle = $(this).parents(".patches-tab-items-img");
            }
          },
        });
        clone.find(".letter-drop-actions .remove").on({
          click: function () {
            // var ProductID = $(this).parents(".patches-tab-items-img").attr("data-product-id");
            var patchesProId = parseInt($(this).parents(".patches-tab-items-img").attr('data-product-id'));
            var appendOrder = parseInt($(this).parents(".patches-tab-items-img").attr('patches-append-order')); 
            var newStateHistory = stateHistory.filter((item) => {
                return !(item.id == patchesProId && item.appendOrder == appendOrder);
            }); 
            stateHistory = newStateHistory;
            saveProduct($(this).parents(".patches-tab-items-img"), 'minus');
            $(this).parents(".patches-tab-items-img").remove();
            if(stateHistory.length > 0){
              var lastItems = stateHistory[stateHistory.length - 1];
              var selectItems = $(`[data-product-id='${lastItems.id}'][patches-append-order='${lastItems.appendOrder}']`).addClass('active').siblings('.patches-tab-items-img').removeClass('active');
            }            
          },
        });
        playMusic(musicObject.NORMAL_FIT_PATCH);
        saveState(clone,'append');
        saveProduct(clone, 'plus')
      }
    }
  });
   $(document).on('click', function(e) {
      var target = $(e.target);
      if (target.parents('.patches-tab-items-img').length == 0 && $(".patches-tab-items-img").has(e.target).length === 0 && target.parents('.bag-product-img-btn-reverse').length == 0 && $(".bag-product-img-btn-reverse").has(e.target).length === 0) {
        $('.patches-tab-items-img').removeClass('active');
      }
    });
    $("body").on("click", ".letter-drop-actions .rotate", function (e) {
      e.preventDefault();
      var RotateEle = $(this).parents(".patches-tab-items-img");
      var currentRotation = RotateEle.attr("data-rotate") || 0;
      var newRotation = parseInt(currentRotation) + 45;
      if (newRotation >= 360) {
        newRotation = 0;
      }
      RotateEle.attr("data-rotate", newRotation).find('.img-wrapper img').eq(0).css("transform", `rotate(${newRotation}deg)`);
      saveState(RotateEle);
    });
    $("body").on("click", ".bag-product-img-btn-reverse", function () {
      if (stateHistory.length > 0) {
        if(stateHistory[stateHistory.length - 1].append) {
          var {id,top,left,rotation,append,appendOrder} = stateHistory[stateHistory.length - 1];
          $(`[data-product-id='${id}'][patches-append-order='${appendOrder}']`).remove();
          stateHistory = stateHistory.slice(0, -1);
          var LastItems = stateHistory[stateHistory.length - 1];
          if (LastItems) {
            var selectItems = $(`[data-product-id='${LastItems.id}'][patches-append-order='${LastItems.appendOrder}']`);
            selectItems.addClass('active').attr('data-rotate',LastItems.rotation).siblings('.patches-tab-items-img').removeClass('active');
            selectItems.css({
              left: LastItems.left,
              top: LastItems.top,
            })
            selectItems.find('.img-wrapper img').eq(0).css("transform", `rotate(${LastItems.rotation}deg)`);
          }
        } else {
          stateHistory = stateHistory.slice(0, -1);
          var lastItems = stateHistory[stateHistory.length - 1];        
          var {id,top,left,rotation,append,appendOrder} = lastItems;
          var selectItems = $(`[data-product-id='${id}'][patches-append-order='${appendOrder}']`);
          selectItems.addClass('active').attr('data-rotate',rotation).siblings('.patches-tab-items-img').removeClass('active');
          selectItems.css({
            left: left,
            top: top,
          })
          selectItems.find('.img-wrapper img').eq(0).css("transform", `rotate(${rotation}deg)`);
        }        
      } else {
        $('.main-bag-product-img-data .patches-tab-items-img ').remove()
      }
    });
    $("body").on("click", "[data-mobile-patched]", function () {
        var GetImg = $(this).html();
        AppendPatch = $(".main-mobile-patch-box .ct-mobile-patch-box");
        $(".step-model-close-btn, .model-overlay").trigger("click");
        AppendPatch.removeAttr("data-open-patches").addClass("disabled");
        AppendPatch.find(".aspect-ratio").html(GetImg);
    });
    var favArray = [];
    function favoriteProduct() {
      var AddFavItems = $("[data-add-fav-item] .swiper-wrapper");
      var AddFavItemsMobile = $("[data-add-fav-item-mobile]");
      AddFavItems.find('.swiper-slide').remove();
      AddFavItemsMobile.find('.mobile-patched-items').remove();
      favArray.map((itemsID) => {
        var ImageHtml = $(`[product-id='${itemsID}']`).prop("outerHTML");
        var parser = new DOMParser();
        var htmlDoc = parser.parseFromString(ImageHtml, 'text/html');
        $(htmlDoc).find('img').removeAttr('style');
        // $(htmlDoc).find('img').removeClass('dropped');
        var DeskFavItemsHtml = `<div class="swiper-slide" data-add-product="${itemsID}">
          <div class="patches-tab-items">
            <button class="btn ct-wishlist-btn fav active">
              <svg viewBox="0 0 24 24">
                <path d="m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path>
              </svg>
            </button>
            <div class="patches-tab-items-img draggable draggable_data icon_image ui-draggable ui-draggable-handle">${$(htmlDoc).find('img').prop("outerHTML")}</div>
          </div>
        </div>`
        var MobFavItemsHtml = `<div class="mobile-patched-items" data-add-product="${itemsID}">
          <div class="mobile-patched-items-inner">
            <button class="btn ct-wishlist-btn fav active">
              <svg viewBox="0 0 24 24">
                <path d="m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path>
              </svg>
            </button>
            <div class="mobile-patched-items-img" data-mobile-patched="">${$(htmlDoc).find('img').prop("outerHTML")}</div>
          </div>
        </div>`;
        AddFavItems.append(DeskFavItemsHtml);
        AddFavItemsMobile.append(MobFavItemsHtml);
      })
      if ($("[data-empty-text]").hide() && AddFavItems.find(".swiper-slide").length == 0 && AddFavItemsMobile.find(".mobile-patched-items").length == 0 ) {
        $("[data-empty-text]").show();
      } else {
        $("[data-empty-text]").hide();
      }
      PatchedSlider;
      $("[data-add-fav-item] .draggable").draggable({
        helper: function () {
          var clone = $(this).clone();
          clone.appendTo(".ui-droppable-layout").css({ zIndex: 10 });
          clone.find("img").eq(0).wrap('<div class="img-wrapper"></div>');
          clone.data("id", Date.now());
          return clone;
        },
        cursor: "move",
        containment: "document",
        start: function (event, ui) {
          // saveState($(this));
        },
      });
    }

  $('body').on('click', '.ct-wishlist-btn', function(e) {
    e.preventDefault();
    var element = $(this).parent().find('img');
    var id = element.attr("product-id");
    var vid = element.find('img').attr("data-varid");
    var src = element.find('img').attr("data-src");
    var title = element.find('img').attr("data-title");
    var price = element.find('img').attr("data-price");
    var isMatchFound = favArray.some(function(item) {
      return item === id;
    });
    if ($(this).hasClass('active')) {
      $(this).removeClass("active");
      $('.patches-tab-items img[product-id="'+id+'"]').parents('.patches-tab-items').find('.ct-wishlist-btn').removeClass('active');
      $('.mobile-patched-items img[product-id="'+id+'"]').parents('.mobile-patched-items').find('.ct-wishlist-btn').removeClass('active');
      if (isMatchFound) {
        favArray = favArray.filter(item => item !== id);
      }
    } else {
      $(this).addClass("active");
      favArray.push(id);
    }
    playMusic(musicObject.SELECT_FAVORITE_PATCH);
    favoriteProduct()
  });

  // Define action constants
  const ADD = "ADD";
  const CHANGE = "CHANGE";
  const UPDATE = "UPDATE";
  const CART = "CART";
  const CART_HTML = "CART_HTML";
  const CART_DRAWER_HTML = "CART_DRAWER_HTML";
  
  // Define function to interact with the server
  const performServerAction = async function(data, action = ADD) {
      let url = "/cart/add.js";
      let method = action.includes("CART") ? "GET" : "POST";
  
      if (action === CHANGE) url = "/cart/change.js";
      if (action === UPDATE) url = "/cart/update.js";
      if (action === CART) url = "/cart.js";
      if (action === CART_HTML) url = "/cart";
      if (action === CART_DRAWER_HTML) url = window.location.pathname;
  
      try {
          // Perform fetch request
          const response = await fetch(url, {
              method: method,
              credentials: "same-origin",
              headers: {
                  "Content-Type": action.includes("HTML") ? "text/html" : "application/json",
                  "X-Requested-With": "xmlhttprequest",
                  "Cache-Control": "no-cache, no-store, must-revalidate",
                  Pragma: "no-cache",
                  Expires: 0
              },
              body: data && JSON.stringify(data)
          });
  
          // Parse response
          const responseData = await (action.includes("HTML") ? response.text() : response.json());
  
          // Handle response
          if (responseData.status) {
              throw new Error(responseData.description);
          }
  
          return responseData;
      } catch (error) {
          console.error(error);
      }
  };
  // Define function to add multiple items to cart
  const addItemsToCart = async function(items) {
    try {
      const response = await performServerAction({ items: items });
      if (!response) return;
      playMusic(musicObject.ADD_TO_BAG);
      $('[data-add-cart]').removeClass('loading');
      $('[data-add-cart]').removeAttr('disabled');
      window.location.href = "/cart";
    } catch (error) {
      console.error(error);
    }
  };

  function randomNumber(min, max) {  
    min = Math.ceil(min); 
    max = Math.floor(max); 
    return Math.floor(Math.random() * (max - min + 1)) + min; 
  }
  
  $('body').on('click', '[data-add-cart]', function() {
    if (stateProduct.length > 0) {
      $(this).addClass('loading');
      $(this).attr('disabled', 'disabled');
      const unsignedUploadPreset = 'doc_codepen_example';
      var bundleId = randomNumber(100000000000, 10000000000000);
      function render(canvasImg) {
        var file = canvasImg;
        var url = `https://api.cloudinary.com/v1_1/demo/upload`;
        var xhr = new XMLHttpRequest();
        var fd = new FormData();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.onreadystatechange = function(e) {
          if (xhr.readyState == 4 && xhr.status == 200) {
            var response = JSON.parse(xhr.responseText);
            var url = response.secure_url;
            var tokens = url.split('/');
            tokens.splice(-2, 0, 'w_450');
            var itemsToAdd = [];
            $.each(stateProduct, function(i, v) {
              itemsToAdd.push({
                quantity: v.qty,
                id: v.vid,
                properties: {
                  preview: tokens.join('/'),
                  _bundleId: bundleId,
                  _bundleItem: "child"
                }
              });
            });
            itemsToAdd.push({
              quantity: 1,
              id: $('[data-default-product]').attr('data-var-id'),
              properties: {
                preview:tokens.join('/'),
                _bundleId: bundleId,
                  _bundleItem: "parent"
              }
            });
            addItemsToCart(itemsToAdd);
          }
        };
        fd.append('upload_preset', unsignedUploadPreset);
        fd.append('tags', 'browser_upload');
        fd.append('file', file);
        xhr.send(fd);
      }
      html2canvas($('[data-custom-image]'), {  
        useCORS: true,
        onrendered: function (canvas) {
          var canvasImg = canvas.toDataURL("image/jpg");
          render(canvasImg);
        }
      });
    }
  });
  /*-------------- Drag and Drop JS End --------------*/

  /*-------------- How to design Modal Start --------------*/
    $('body').on('click','.gudline-popup .ct-button-cart', function () {
      $(`.modal[data-model-name="${$(this).attr('data-model-name')}"]`).addClass('open');
      $("body").addClass("overflow-hidden");
    })
    $('body').on('click','.modal .modal-close', function () {
      $('.modal').removeClass('open');
      $("body").removeClass("overflow-hidden");
    });

    $(document).mouseup(function(e){
      if (!$(".modal .modal-container").is(e.target) && $(".modal .modal-container").has(e.target).length === 0){
          $(".modal").removeClass('open'); 
      } 
    }); 
  /*-------------- How to design Modal End --------------*/
  
});